import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

class Map {
    constructor(root) {
        this.root = root;
        this.mapElement = root.querySelector('.map__leaflet');
        if (!this.mapElement) return;

        this.mapData = JSON.parse(this.mapElement.getAttribute('data-map-settings'));

        this.map = null;
        this.defaultZoom = 13;
        this.boundsPadding = 20;
        this.bounds = [];
        this.style = 'osm';

        this.initMap();
        this.setLayers();
        this.setMarkers();
        this.setBounds();
    }

    initMap() {
        this.map = L.map(this.mapElement.id);
    }

    layerProvider() {
        switch (this.style) {
        case 'osm':
            return [
                'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
                {
                    attribution: '&copy; OpenStreetMap contributors',
                },
            ];
        case 'CartoDB.Positron':
            return [
                'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
                {
                    attribution:
                            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO Positron</a>',
                    subdomains: 'abcd',
                    maxZoom: 20,
                },
            ];
        case 'CartoDB.Voyager':
            return [
                'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
                {
                    attribution:
                            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
                    subdomains: 'abcd',
                    maxZoom: 20,
                },
            ];
        case 'OpenStreetMap.Mapnik':
        default:
            return [
                'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
                {
                    maxZoom: 19,
                    attribution:
                            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                },
            ];
        }
    }

    setLayers() {
        const { map } = this;
        L.tileLayer(...this.layerProvider()).addTo(map);
    }

    setMarkers() {
        const {
            mapData: { markers },
            map,
        } = this;

        markers.forEach((marker) => {
            const m = L.marker([marker.lat, marker.lng]);
            m.addTo(map);

            this.bounds.push([marker.lat, marker.lng]);
        });
    }

    setBounds() {
        const {
            bounds,
            map,
            mapData: { zoom },
            defaultZoom,
            boundsPadding,
        } = this;

        if (bounds.length === 1) {
            map.setView(bounds[0], zoom || defaultZoom);
        } else if (bounds.length > 1) {
            map.fitBounds(bounds, { padding: [boundsPadding, boundsPadding] });
        }
    }
}

const initMapBlocks = () => {
    const blocks = document.querySelectorAll('.map-block');
    if (!blocks) return;

    const markerIcon = `${window.location.origin}/wp-content/themes/diabolo-poivre/dist/img/map_pin.png`;
    delete L.Icon.Default.prototype._getIconUrl; // eslint-disable-line

    L.Icon.Default.mergeOptions({
        iconRetinaUrl: markerIcon,
        iconUrl: markerIcon,
        shadowUrl: undefined,
    });

    blocks.forEach((block) => {
        new Map(block); // eslint-disable-line
    });
};

export { Map, initMapBlocks };
